import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "./dashboard.css";

const DESKTOP_MEDIA_QUERY = "(min-width: 1024px)";

const getIsDesktop = () =>
  typeof window !== "undefined" && window.matchMedia(DESKTOP_MEDIA_QUERY).matches;

function Dashboard() {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => getIsDesktop());

  useEffect(() => {
    const mediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);

    const syncSidebarWithViewport = (event) => {
      setIsSidebarOpen(event.matches);
    };

    setIsSidebarOpen(mediaQuery.matches);
    mediaQuery.addEventListener("change", syncSidebarWithViewport);

    return () => {
      mediaQuery.removeEventListener("change", syncSidebarWithViewport);
    };
  }, []);

  useEffect(() => {
    if (!getIsDesktop()) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  const toggleSidebar = () => {
    if (getIsDesktop()) {
      return;
    }

    setIsSidebarOpen((previous) => !previous);
  };

  const closeSidebarOnMobile = () => {
    if (!getIsDesktop()) {
      setIsSidebarOpen(false);
    }
  };

  const navLinkClassName = ({ isActive }) =>
    `sidebar__link${isActive ? " is-active" : ""}`;

  return (
    <div className="dashboard">
      <header className="dashboard__header">
      <img src="/yavola_logo.png" alt="Yavola Logo" className="dashboard__brand-logo" />
        <div className="dashboard__brand" aria-label="Yavola business dashboard">
          <span className="dashboard__brand-accent">Yavola</span> Business Console
        </div>
        <button
          type="button"
          className="dashboard__menu-button"
          onClick={toggleSidebar}
          aria-expanded={isSidebarOpen}
          aria-controls="dashboard-navigation"
        >
          <span className="dashboard__menu-icon" aria-hidden="true" />
          Menu
        </button>
      </header>

      <div className="dashboard__body">
        <aside
          id="dashboard-navigation"
          className={`sidebar${isSidebarOpen ? " sidebar--open" : ""}`}
          aria-label="Primary navigation"
        >
          <nav className="sidebar__nav">
            <NavLink
              to="ManageBookings"
              className={navLinkClassName}
              onClick={closeSidebarOnMobile}
            >
              <span className="sidebar__icon" aria-hidden="true">
                📅
              </span>
              <div className="sidebar__details">
                <span className="sidebar__label">Bookings</span>
                <span className="sidebar__hint">Review reservations</span>
              </div>
            </NavLink>
            <NavLink
              to="ManagePricing"
              className={navLinkClassName}
              onClick={closeSidebarOnMobile}
            >
              <span className="sidebar__icon" aria-hidden="true">
                💰
              </span>
              <div className="sidebar__details">
                <span className="sidebar__label">Pricing</span>
                <span className="sidebar__hint">Update session rates</span>
              </div>
            </NavLink>
            <NavLink to="ManageCars" className={navLinkClassName} onClick={closeSidebarOnMobile}>
              <span className="sidebar__icon" aria-hidden="true">
                🚗
              </span>
              <div className="sidebar__details">
                <span className="sidebar__label">Cars</span>
                <span className="sidebar__hint">Update fleet availability</span>
              </div>
            </NavLink>
          </nav>
        </aside>

        <div
          className={`sidebar-backdrop${isSidebarOpen ? " sidebar-backdrop--visible" : ""}`}
          onClick={closeSidebarOnMobile}
          aria-hidden="true"
        />

        <main className="dashboard__content">
          <div className="dashboard__content-inner">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}

export default Dashboard;
